import { Schema } from 'effect';
import { HttpApiMiddleware, HttpApiSchema, HttpApiSecurity } from 'effect/unstable/httpapi';

/**
 * Host-neutral HTTP authorization contract.
 *
 * API definitions declare that authorization is required; each application
 * supplies the policy and credential validation through an Effect Layer.
 */
export const Unauthorized = HttpApiSchema.WithHeaders(
  Schema.Struct({
    object: Schema.Literal('error'),
    code: Schema.Literal('UNAUTHORIZED'),
    error: Schema.Literal('unauthorized'),
    message: Schema.String,
  }).pipe(HttpApiSchema.status(401)),
  {
    'www-authenticate': Schema.String,
  },
).annotate({ identifier: 'Unauthorized' });

export class Authorization extends HttpApiMiddleware.Service<Authorization>()(
  '@okrapdf/HttpApiAuthorization',
  {
    security: {
      bearer: HttpApiSecurity.bearer,
      apiKey: HttpApiSecurity.apiKey({ key: 'x-okra-api-key', in: 'header' }),
      basic: HttpApiSecurity.basic,
    },
    error: Unauthorized,
  },
) {}
